import React from 'react'
import BrokenRoute from './BrokenRoute'
import { Button } from 'antd'
import notFoundIcon from '../../assets/images/NotFound404.svg';
import { useNavigate } from 'react-router';

export default function PageNotFound({ pageName = 'Page' }: { pageName?: string }) {
    const navigate = useNavigate();
    return (
        <BrokenRoute
            icon={notFoundIcon}
            title={`${pageName} Not Found`}
            message="The page you are looking for might have been removed or is temporarily unavailable"
            actions={
                <Button
                    type='primary'
                    className='btn-primary btn-md'
                    onClick={() => navigate('/')}
                >Go to Homepage</Button>
            }
        />
    )
}
